// Журнал выкаток и проверок восстановления (data-model.md, observability.*; FR-042, FR-043б).
import { z } from '../kernel/zod.ts';
import { IdSchema, TimestampSchema } from '../kernel/common.ts';

export const DeploymentSchema = z.object({
  id: IdSchema,
  version: z.string(),
  /** Короткий коммит — тот же, что в углу интерфейса. */
  commit: z.string(),
  deployedAt: TimestampSchema,
  /** Кто выкатил: имя учётной записи на стенде, не пользователь сервиса. */
  deployedBy: z.string(),
  /** Что вошло. */
  contents: z.string(),
  /** Как откатить. */
  rollback: z.string(),
  /** Какая копия сделана перед миграцией. */
  backupRef: z.string().optional(),
});
export type Deployment = z.infer<typeof DeploymentSchema>;

export const restoreCheckResults = ['ok', 'failed'] as const;
export const RestoreCheckResultSchema = z.enum(restoreCheckResults);

export const RestoreCheckSchema = z.object({
  id: IdSchema,
  checkedAt: TimestampSchema,
  backupRef: z.string(),
  result: RestoreCheckResultSchema,
  durationS: z.number().nonnegative(),
  notes: z.string().optional(),
});
export type RestoreCheck = z.infer<typeof RestoreCheckSchema>;
